import React from 'react';
import { styled } from '@mui/system';
import Tooltip from '@mui/material/Tooltip';
import { SOCIAL_MEDIA } from 'variables/menu';
import InstagramLogo from 'assets/icons/footer/instagram.svg?react';
import TiktokLogo from 'assets/icons/footer/tiktok.svg?react';
import YoutubeLogo from 'assets/icons/footer/youtube.svg?react';
import TelegramCommunityLogo from 'assets/icons/footer/telegram-community.svg?react';
import TelegramChannelLogo from 'assets/icons/footer/telegram-channel.svg?react';
import TelegramBotLogo from 'assets/icons/footer/telegram-bot.svg?react';
import DiscordLogo from 'assets/icons/footer/discord.svg?react';
import SpotifyLogo from 'assets/icons/footer/spotify.svg?react';
import XLogo from 'assets/icons/footer/x.svg?react';
import FacebookLogo from 'assets/icons/footer/facebook.svg?react';
import LinkedinLogo from 'assets/icons/footer/linkedin.svg?react';

const Wrapper = styled('div')(({ theme }) => ({
  marginTop: 15,
  display: 'flex',
  gap: 24,
  flexWrap: 'wrap',
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center'
  }
}));

const FooterMedia = () => {
  const iconMap = React.useMemo(
    () => ({
      instagram: InstagramLogo,
      tiktok: TiktokLogo,
      youtube: YoutubeLogo,
      telegram: TelegramCommunityLogo,
      telegram_channel: TelegramChannelLogo,
      telegram_bot: TelegramBotLogo,
      discord: DiscordLogo,
      spotify: SpotifyLogo,
      x: XLogo,
      facebook: FacebookLogo,
      linkedin: LinkedinLogo
    }),
    []
  );

  // Icon-only links need an accessible name, otherwise screen readers
  // announce them as bare "link".
  const labelMap = React.useMemo(
    () => ({
      instagram: 'Instagram',
      tiktok: 'TikTok',
      youtube: 'YouTube',
      telegram: 'Telegram',
      telegram_channel: 'Telegram',
      telegram_bot: 'Telegram',
      discord: 'Discord',
      spotify: 'Spotify',
      x: 'X',
      facebook: 'Facebook',
      linkedin: 'LinkedIn'
    }),
    []
  );

  return (
    <Wrapper>
      {Object.entries(SOCIAL_MEDIA).filter(([, v]) => v).map(([key, value]) => {
        const IconComponent = iconMap[key];
        return (
          <a
            key={key}
            href={value}
            aria-label={labelMap[key] || key}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              import('services/analytics').then((Analytics) => {
                Analytics.default.event('FooterSocialClick', {
                  path: value
                });
              });
            }}>
            <Tooltip title={value}>
              <IconComponent />
            </Tooltip>
          </a>
        );
      })}
    </Wrapper>
  );
};

export default FooterMedia;
